import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { showErrorToastMessage } from "../../../../../component/Toasts/Toasts";
import * as actions from "../../../../../Redux/Actions/index";
import { Strings } from "../../../../../constant/Strings";


const DeleteWorkAchievements = (props: any) => {
  const { id, hideDeleteWorkAchievements } = props;
  const { deleteSuccess, confirmDelete, cancel, submit } = Strings;
  const dispatch = useDispatch();
  const handleDelete = () => {
    dispatch(actions.deleteEmployeeWorkAchievementsAction(id));
    hideDeleteWorkAchievements();
    showErrorToastMessage(deleteSuccess)
  };
  const deleteEmployeeWorkAchievements = useSelector(
    (state: any) => state.employeeReducer.deleteEmployeeWorkAchievements
  );
  return (
      <div className="container">
      <div className="row mx-auto">{confirmDelete}</div>
      <div className="modal-btn-wrapper mt-5 mx-auto">
        <div>
          <button
            className="btn cancel-btn buttonsize"
            onClick={hideDeleteWorkAchievements}
          >
            {cancel}
          </button>
        </div>
        <div>
          <button
            className="btn add-submit-button buttonsize"
            onClick={handleDelete}
          >
            {submit}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteWorkAchievements;
